import React from 'react'
import './Footer.css'
 const Footer = () => {
  return (
     <div id='footer'> 
      <h4>This site is made with <span>&hearts;</span> | All rights are reservd&reg; Manish Sharma</h4>
    </div>
   )
}

export default Footer